import React from 'react';
import { Users, Code, Palette, Cloud, CheckCircle } from 'lucide-react';
import { teamContent } from '../../data/mock';

const deptIcons = {
  'Engineering': Code,
  'Product': Users,
  'Design': Palette,
  'Cloud & DevOps': Cloud,
  'Quality Assurance': CheckCircle
};

export const TeamSection = () => {
  return (
    <section id="team" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            {teamContent.title}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#1e3a5f] leading-tight">
            {teamContent.subtitle}
          </h2>
          <p className="mt-6 text-lg text-gray-600 leading-relaxed">
            {teamContent.description}
          </p>
        </div>

        {/* Team Philosophy */}
        <div className="mb-16 p-8 rounded-2xl bg-white border border-gray-100 shadow-sm">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-16 h-16 rounded-2xl bg-[#f26522] flex items-center justify-center flex-shrink-0">
              <Users className="w-8 h-8 text-white" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-[#1e3a5f] mb-2">Our Philosophy</h3>
              <p className="text-gray-600 leading-relaxed">
                {teamContent.philosophy}
              </p>
            </div>
          </div>
        </div>

        {/* Departments */}
        <div className="mb-16">
          <h3 className="text-xl font-semibold text-[#1e3a5f] text-center mb-8">Our Departments</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {teamContent.departments.map((dept, i) => {
              const Icon = deptIcons[dept.name] || Users;
              return (
                <div
                  key={i}
                  className="group p-5 rounded-xl bg-white border border-gray-100 hover:border-[#f26522]/30 hover:shadow-lg transition-all duration-300 text-center"
                >
                  <div className="w-12 h-12 rounded-lg bg-[#1e3a5f]/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-[#1e3a5f] transition-colors">
                    <Icon className="w-6 h-6 text-[#1e3a5f] group-hover:text-white transition-colors" />
                  </div>
                  <h4 className="font-semibold text-[#1e3a5f] mb-1">{dept.name}</h4>
                  <p className="text-xs text-gray-500">{dept.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center px-6 py-3 bg-[#1e3a5f] text-white font-medium rounded-lg hover:bg-[#152a45] transition-colors"
          >
            Work With Our Team
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};
